<template>
  <div id="app" @mousemove="moveEvent" @click="moveEvent">
    <!-- <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition> -->
    <transition name="fade" mode="out-in">
      <!--需要缓存的页面-->
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    </transition>
    <transition name="fade" mode="out-in">
      <!--不需要缓存的页面-->
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </transition>
  </div>
</template>

<script>
import { EventBus } from "./utils/event-bus";
import { conn } from "./utils/WebIM";
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  computed: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  mounted() {
    if (this._isMobile()) {
      console.log("手机端");
      // this.$router.replace('/');
    } else {
      console.log("pc端");
      this.$router.replace("/");
    }
  },

  beforeMount() {
    const userInfo =
      localStorage.getItem("USER_INFO") && JSON.parse(localStorage.getItem("USER_INFO"));
    if (userInfo) {
      const userName = "hafa" + userInfo.id;
      // const password = userInfo.password;

      console.log(WebIM, "opsospps");
      let options = {
        user: userName,
        pwd: "123456",
        appKey: WebIM.config.appkey,
      };
      conn.open(options);
    }
  },
  methods: {
    moveEvent() {
      // let path = ["/login", "/monitor"];
      // if (!path.includes(this.$route.path)) {
      //   //如果不是登录页面的话页面停止进行30分钟后清空session
      //   clearTimeout(this.timmer);
      //   this.init();
      // }
    },
    init() {
      // this.timmer = setTimeout(() => {
      //   EventBus.$emit("logOutUser", "会话超时，退出登陆");//触发退出事件
      //   this.$message({
      //     message: "会话超时，退出登陆",
      //     type: "warning",
      //   });
      // }, 4*60*60*1000); //设置4个小时不操作清空session进入登陆页面
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
    },
  },
};
</script>

<style lang="scss">
@import "themePath/public.scss";
@import "themePath/elDialog.scss";
@import "themePath/table.scss";
body .el-table th.gutter {
  display: table-cell !important;
}

body .el-table colgroup.gutter {
  display: table-cell !important;
}
#app {
  background: #f4f5f5;
}

.mask {
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
}

.pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue